import { createFeatureSelector, createSelector } from '@ngrx/store';
import { carmProgramsListKey, ProgramsListState } from '../reducers/program-list.reducer'

export const selectProgramListState = createFeatureSelector<ProgramsListState>(
  carmProgramsListKey,
);

export const getInactivePrograms = createSelector(
  selectProgramListState,
  (state: ProgramsListState) =>  {
      if ( state && state.inactivePrograms && state.inactivePrograms.length > 0) {
        return  state.inactivePrograms;
      } else {
        return [];
      }
  },
);


